export enum ModeOptions {
  RETRIEVAL = 'retrieval',
  PICKUP = 'pickup',
  DROPOFF = 'dropoff',
  RETRIEVALS = 'retrievals'
}
